import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function ZoomMenu({ zoom, zoomIn, zoomOut }: Props) {
  const canZoomIn = true;
  const canZoomOut = true;

  return (
    <div className={styles.zoomMenu}>
      <div
        className={classNames(styles.button, { [styles.disabled]: !canZoomIn })}
        onClick={() => canZoomIn && zoomIn()}
      >
        +
      </div>
      <div
        className={classNames(styles.button, {
          [styles.disabled]: !canZoomOut,
        })}
        onClick={() => canZoomOut && zoomOut()}
      >
        -
      </div>
    </div>
  );
}

export { ZoomMenu };
